import { makeCygnusApiCall } from "../../../../../api/api"; // adjust this import as needed

/**
 * Fetches the list of engagement letter templates.
 * @param setTemplateAPIProgress - State setter for showing/hiding the loading spinner.
 * @returns An array of template data on success, otherwise undefined.
 */
export const fetchEngagementTemplateData = async () => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/engagement-letter/templates/`,
    show_message: true,
    customized_success_message: "Fetched engagement letter templates.",
    customized_failure_message: "Unable to fetch engagement templates.",
    customized_error_message:
      "Something went wrong while fetching templates. Please contact support.",
    isblob: false,
    forMDM: true,
  });

  if (response.success && response.data) {
    return response.data;
  }
};
